import EarnStar from '../assets/earnStar.png';
import Footer from '../components/Footer';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import MODALDOWNLOADICON from '../assets/modalDownload.png';
import { motion } from 'framer-motion';

const Container = {
    width: '100%',
    height: 'auto',
    background: ' #060514',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    fontFamily: 'Space Grotesk, Sans Serif',
    overflow: 'hidden',
};

const ModalIcon = styled.img`
    margin-top: 20px;
    margin-bottom: 20px;
    `

const Underlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(120, 3, 255, 0.05)
    `

const RadialGradient = styled.div`
    position: absolute;
    top: -100px;
    right: -100px;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientA = styled.div`
    position: absolute;
    top: 400px;
    left: 0;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientB = styled.div`
    position: absolute;
    top: 900px;
    left: -175px;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientC = styled.div`
    position: absolute;
    right: -100px;
    bottom: -175px;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const InfoWrapper = {
    width: '70%',
    maxWidth: '100%',
    height: 'auto',
    border: '1px solid rgba(0, 122, 204, 0.5)',
    backgroundColor: 'rgba(0, 122, 204, 0.05)',    
    borderRadius: '20px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
    margin: '10px 0px',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
};

const InfoWrapperHover = {
    ...InfoWrapper,
    transform: 'scale(1.02)',
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.35)',
};

const InfoWrapperTopRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: '20px',
    gap: '10px',
};

const InfoText = {
    fontSize: '13px',
    color: '#dfe6f0',
    fontWeight: '400',
    lineHeight: '1.6',
};

const InfoTitle = {
    fontSize: '20px',
    color: 'rgba(255, 255, 255, 0.9)',
    fontWeight: '700',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)',
};

const ModalTopTitle = styled.div`
    color: rgba(0, 0, 0, 0.95);
    font-size: 24px;
    font-weight: 600;
    `
const OSRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80%;
    margin-top: 20px;
    `
const OSRowButton = styled.button`
    border: 1px solid #007acc;
    background: #007acc;
    border-radius: 10px;
    width: 100%;
    cursor: pointer;
    padding: 10px 0px;
    font-family: Space Grotesk, Sans Serif;
    color: white;
    font-size: 16px;
    `
const OSRowButtonA = styled.button`
    border: 1px solid rgba(0, 122, 204, 0.25);
    background: rgba(0, 122, 204, 0.25);
    border-radius: 10px;
    width: 100%;
    cursor: pointer;
    padding: 10px 0px;
    font-family: Space Grotesk, Sans Serif;
    color: #060514;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 20px;
    `

const IconStyle = {
    width: '30px',
    height: '30px',
};


const TitleWrapper = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '15px',
    marginBottom: '15px',
    zIndex: '2',
};

const MainWrapper = {
    paddingBottom: '125px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    zIndex: '2',
};

const Title = {
    fontSize: '22px',
    color: 'white',
    fontWeight: '600',
    marginLeft: '15px',
};

const Button = {
    padding: '7.5px 0px',
    background: '#007acc', 
    borderRadius: '10px',
    width: '100%',
    border: '2px solid #007acc',
    fontWeight: '700',
    fontSize: '12px',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    textAlign: 'center',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
    marginTop: '20px',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: '#444444',
        transform: 'scale(1.05)',
    },
};

const ButtonText = {
        fontSize: '13px',
        color: 'white',
        fontWeight: '600',
        lineHeight: '1.6',
    };

const About = () => {

    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

/////////////////////////////////////////////////////////////////////////////////////////////

const handleAndroidDownload = async () => {
    setTimeout(() => {
        window.open('https://play.google.com/store/apps/details?id=com.HydrixApp', '_blank');
    }, 500);

}

const handleIosDownload = async () => {
    setTimeout(() => {
        window.open('https://apps.apple.com/us/app/hydrix/id6739980773', '_blank');
    }, 500);

}

/////////////////////////////////////////////////////////////////////////////////////////////

    return (
        <div style={Container}>
            <RadialGradient />
            <RadialGradientA />
            <RadialGradientB />
            <RadialGradientC />
            <div style={TitleWrapper}>
                <div style={Title}>About</div>
            </div>
            <div style={MainWrapper}>
                <div style={InfoWrapper}>
                    <div style={InfoWrapperTopRow}>
                        <img src={EarnStar} />
                        <div style={InfoTitle}>Gems</div>
                    </div>
                    <div style={InfoText}>Hydrix Gems are a valuable in-app currency that
                        can be earned through daily mining or by completing engaging tasks 
                        on the Telegram mini app. These gems provide users with a flexible 
                        and rewarding experience, as they can be exchanged at any time for 
                        Hx tokens or a variety of other exciting items. Start mining and 
                        exploring today to maximize your rewards with Hydrix Gems!
                    </div>
                    <button style={Button}>
                        <div style={ButtonText}>Exchange Coming Soon</div>
                    </button>
                </div>
                <div style={InfoWrapper}>
                    <div style={InfoWrapperTopRow}>
                        <img src={EarnStar} />
                        <div style={InfoTitle}>Difference between Hx and Gems</div>
                    </div>
                    <div style={InfoText}>The Hx token and Hydrix Gems serve different
                        purposes within the Hydrix ecosystem. Gems are not a blockchain 
                        token but act as the in-app currency for the Hydrix Telegram 
                        mini app. They can be earned through daily mining and tasks and 
                        traded anytime before the Token Generation Event (TGE) for Hx tokens. 
                        Additionally, Gems can be used for other exciting rewards, making 
                        them a versatile currency for users. In contrast, Hx tokens are 
                        blockchain-based assets with broader utility and value beyond the 
                        Telegram app.
                    </div>
                </div>
                <div style={InfoWrapper}>
                    <div style={InfoWrapperTopRow}>
                        <img src={EarnStar} />
                        <div style={InfoTitle}>Do I use the same account as the app?</div>
                    </div>
                    <div style={InfoText}>Your Hydrix account on the Telegram mini app is 
                        separate from your account in the main Hydrix app. This is because 
                        we utilize Telegram's account security and setup for the mini app. 
                        However, you will have the ability to link your Telegram account 
                        with your Hydrix app account seamlessly through the Hydrix Gem 
                        Exchange, ensuring a unified experience across both platforms.
                    </div>
                        <button onClick={() => setIsDownloadModalOpen(true)} style={Button}>
                            <div style={ButtonText}>Get The App</div>
                        </button>
                    
                </div>
                <div style={InfoWrapper}>
                    <div style={InfoWrapperTopRow}>
                        <img src={EarnStar} />
                        <div style={InfoTitle}>What are the value of Gems?</div>
                    </div>
                    <div style={InfoText}>Mining Gems through the Telegram mini app and 
                        mining Hydrix through the main app are designed to offer similar 
                        long-term value, though they may not be exactly equivalent. Both 
                        methods contribute meaningfully to your overall rewards within 
                        the Hydrix ecosystem, ensuring fairness and encouraging participation 
                        on either platform.
                    </div>
                </div>
            </div>
            {isDownloadModalOpen && (
    <motion.div 
        initial={{ y: "100%" }} 
        animate={{ y: "0%" }} 
        transition={{ duration: 0.5, ease: "easeInOut" }}
        style={{
            position: "fixed",
            top: "25%",
            width: "80%",
            height: "auto",
            background: "#eee",
            borderRadius: "10px",
            boxShadow: "0 -4px 10px rgba(0, 0, 0, 0.2)",
            display: "flex",
            flexDirection: 'column',
            alignItems: "center",
            justifyContent: "center",
            zIndex: "999",
        }}
        onClick={() => setIsDownloadModalOpen(false)}
    >
        <ModalIcon src={MODALDOWNLOADICON} />
        <ModalTopTitle>Choose Your Device</ModalTopTitle>
        <OSRow>
            <OSRowButton onClick={handleAndroidDownload}>
                Android
            </OSRowButton>
            <OSRowButtonA onClick={handleIosDownload}>
                ios
            </OSRowButtonA>
        </OSRow>
        
    </motion.div>
)}
            <Footer />
        </div>

    )
};

export default About;